const dept_management_zh = {
  edit_dept_info:'编辑部门信息',
  empty_name:'请输入部门名称',
  empty_full_name:'请选择上级名称',
  empty_super_name:'请输入部门全称',
  del_dept:'是否删除部门'
}

export default dept_management_zh



// WEBPACK FOOTER //
// ./src/common/lang/dept_management/dept_management_zh.js